import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { CctvAnalyzer } from "./components/CctvAnalyzer";
import { LockerLockComponent } from "./components/LockerLockComponent";
import { PlanterMiniGame } from "./components/planter-minigame";
// import { PlanterMiniGame } from "./components/PlanterMiniGame";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);

// Register CCTV Analyzer component
window.customElements.define("cctv-analyzer", CctvAnalyzer);

// Register Planter Mini Game Component
window.customElements.define("planter-mini-game", PlanterMiniGame);

// Regsister Fingerprint Analyser component
window.customElements.define("locker-lock-component", LockerLockComponent);
